import { keys } from './keys';

export const en = {
  [keys.english]: 'EN',
  [keys.spanish]: 'ES',
};
